import { isNil, pick } from 'lodash-es';
import {
  ADD_FLEET,
  ADD_FLEET_IS_ERROR,
  ADD_FLEET_IS_PENDING,
  FETCH_FLEET,
  FETCH_FLEET_BY_DEPLOYMENT_ENVIRONMENT,
  FETCH_FLEET_BY_DEPLOYMENT_ENVIRONMENT_IS_ERROR,
  FETCH_FLEET_BY_DEPLOYMENT_ENVIRONMENT_IS_PENDING,
  FETCH_FLEET_BY_ID,
  FETCH_FLEET_BY_ID_IS_ERROR,
  FETCH_FLEET_BY_ID_IS_PENDING,
  FETCH_FLEET_IS_ERROR,
  FETCH_FLEET_IS_PENDING,
  FleetActions,
  FleetState,
  REMOVE_FLEET,
  REMOVE_FLEET_IS_ERROR,
  REMOVE_FLEET_IS_PENDING,
  RESERVE_HOST,
  RESERVE_HOST_BULK,
  RESERVE_HOST_BULK_IS_ERROR,
  RESERVE_HOST_BULK_IS_PENDING,
  RESERVE_HOST_IS_ERROR,
  RESERVE_HOST_IS_PENDING,
  SORT,
  UNRESERVE_HOST,
  UNRESERVE_HOST_IS_ERROR,
  UNRESERVE_HOST_IS_PENDING,
  UPDATE_FLEET,
  UPDATE_FLEET_IS_ERROR,
  UPDATE_FLEET_IS_PENDING,
} from 'services/GameHosting/Fleet/types';
import { ACTION_PENDING, CLEAN_ERROR } from 'utils/apiActionTypes';
import { addNew, parseError, sort } from 'utils/functions';
import manageError from 'utils/logging/manageError';

const INITIAL_STATE = {
  fleets: [],
  fleet: {},
  sortBy: 'name',
  sortDirection: 'ASC',
  fetchFleetsIsCompleted: false,
  fetchFleetsIsPending: false,
  fetchFleetsIsError: null,

  fetchFleetByIsCompleted: false,
  fetchFleetByIsPending: false,
  fetchFleetByIsError: null,

  fetchByDepEnvIsCompleted: false,
  fetchByDepEnvIsPending: false,
  fetchByDepEnvIsError: null,

  isPending: false,
  isCompleted: false,
  isError: null,

  addFleetIsCompleted: false,
  addFleetIsPending: false,
  addFleetIsError: null,

  updateFleetIsCompleted: false,
  updateFleetIsPending: false,
  updateFleetIsError: null,

  removeIsCompleted: false,
  removeIsPending: false,
  removeIsError: null,

  reserveHostBulkIsCompleted: false,
  reserveHostBulkIsPending: false,
  reserveHostBulkIsError: null,

  reserveHostIsCompleted: false,
  reserveHostIsPending: false,
  reserveHostIsError: null,

  unreserveHostIsCompleted: false,
  unreserveHostIsPending: false,
  unreserveHostIsError: null,
} satisfies FleetState;

const fleetReducer = (previousState: FleetState | undefined, action: FleetActions): FleetState => {
  const state = previousState ?? INITIAL_STATE;

  switch (action.type) {
    case FETCH_FLEET:
      return {
        ...state,
        fleets: action.data ?? [],
        fetchFleetsIsCompleted: true,
        fetchFleetsIsPending: false,
        fetchFleetsIsError: null,
      };
    case FETCH_FLEET_IS_PENDING:
      return {
        ...state,
        fetchFleetsIsCompleted: false,
        fetchFleetsIsPending: true,
        fetchFleetsIsError: null,
      };
    case FETCH_FLEET_IS_ERROR:
      return {
        ...state,
        fetchFleetsIsCompleted: true,
        fetchFleetsIsPending: false,
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchFleetsIsError: parseError(action.error.message),
      };

    case FETCH_FLEET_BY_ID:
      return {
        ...state,
        fleet: action.data ?? {},
        fetchFleetByIsCompleted: true,
        fetchFleetByIsPending: false,
        fetchFleetByIsError: null,
      };
    case FETCH_FLEET_BY_ID_IS_PENDING:
      return {
        ...state,
        fetchFleetByIsCompleted: false,
        fetchFleetByIsPending: true,
        fetchFleetByIsError: null,
      };
    case FETCH_FLEET_BY_ID_IS_ERROR:
      return {
        ...state,
        fetchFleetByIsCompleted: true,
        fetchFleetByIsPending: false,
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchFleetByIsError: parseError(action.error.message),
      };

    case FETCH_FLEET_BY_DEPLOYMENT_ENVIRONMENT:
      return {
        ...state,
        fleets: sort(action.data ?? [], {
          sortBy: state.sortBy,
          sortDirection: state.sortDirection,
        }),
        fetchByDepEnvIsCompleted: true,
        fetchByDepEnvIsPending: false,
        fetchByDepEnvIsError: null,
      };
    case FETCH_FLEET_BY_DEPLOYMENT_ENVIRONMENT_IS_PENDING:
      return {
        ...state,
        fetchByDepEnvIsCompleted: false,
        fetchByDepEnvIsPending: true,
        fetchByDepEnvIsError: null,
      };
    case FETCH_FLEET_BY_DEPLOYMENT_ENVIRONMENT_IS_ERROR:
      return {
        ...state,
        fetchByDepEnvIsCompleted: true,
        fetchByDepEnvIsPending: false,
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchByDepEnvIsError: parseError(action.error.message),
      };

    case RESERVE_HOST_BULK:
      return {
        ...state,
        reserveHostBulkIsCompleted: true,
        reserveHostBulkIsPending: false,
        reserveHostBulkIsError: null,
      };
    case RESERVE_HOST_BULK_IS_PENDING:
      return {
        ...state,
        reserveHostBulkIsCompleted: false,
        reserveHostBulkIsPending: true,
        reserveHostBulkIsError: null,
      };
    case RESERVE_HOST_BULK_IS_ERROR:
      return {
        ...state,
        reserveHostBulkIsCompleted: true,
        reserveHostBulkIsPending: false,
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        reserveHostBulkIsError: parseError(action.error.message),
      };

    case RESERVE_HOST:
      return {
        ...state,
        reserveHostIsCompleted: true,
        reserveHostIsPending: false,
        reserveHostIsError: null,
      };
    case RESERVE_HOST_IS_PENDING:
      return {
        ...state,
        reserveHostIsCompleted: false,
        reserveHostIsPending: true,
        reserveHostIsError: null,
      };
    case RESERVE_HOST_IS_ERROR:
      return {
        ...state,
        reserveHostIsCompleted: true,
        reserveHostIsPending: false,
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        reserveHostIsError: parseError(action.error.message),
      };

    case UNRESERVE_HOST:
      return {
        ...state,
        unreserveHostIsCompleted: true,
        unreserveHostIsPending: false,
        unreserveHostIsError: null,
      };
    case UNRESERVE_HOST_IS_PENDING:
      return {
        ...state,
        unreserveHostIsCompleted: false,
        unreserveHostIsPending: true,
        unreserveHostIsError: null,
      };
    case UNRESERVE_HOST_IS_ERROR:
      return {
        ...state,
        unreserveHostIsCompleted: true,
        unreserveHostIsPending: false,
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        unreserveHostIsError: parseError(action.error.message),
      };

    case ADD_FLEET: {
      const { data, originalDepEnvId } = action;

      if (isNil(data)) {
        return state;
      }

      const indexName = state.fleets.findIndex((fleet) => isNil(fleet.id));
      let fleetsToUpdate;

      if (originalDepEnvId === data.deploymentEnvironmentId) {
        if (indexName === -1) {
          fleetsToUpdate = addNew(data, state.fleets);
        } else {
          // should not happend
          manageError(new Error('Unexpected fleet with empty id'), { fleets: JSON.stringify(state.fleets ?? []) });
          fleetsToUpdate = state.fleets.map((fleet, index) => {
            if (index !== indexName) {
              return fleet;
            }

            return data;
          });
        }

        return {
          ...state,
          fleets: fleetsToUpdate,
          addFleetIsCompleted: true,
          addFleetIsPending: false,
          addFleetIsError: null,
        };
      }

      return {
        ...state,
        addFleetIsCompleted: true,
        addFleetIsPending: false,
        addFleetIsError: null,
      };
    }

    case ADD_FLEET_IS_PENDING:
      return {
        ...state,
        addFleetIsCompleted: false,
        addFleetIsPending: true,
        addFleetIsError: null,
      };
    case ADD_FLEET_IS_ERROR:
      return {
        ...state,
        addFleetIsCompleted: true,
        addFleetIsPending: false,
        addFleetIsError: action.error,
      };

    case UPDATE_FLEET: {
      const { data, originalDepEnvId } = action;

      if (isNil(data)) {
        return state;
      }

      let fleets;

      if (originalDepEnvId === data.deploymentEnvironmentId) {
        fleets = state.fleets.map((item) => {
          // not same id
          if (item.id !== data.id) {
            return item;
          }

          return data;
        });
      } else {
        // keep fleets with different id and different name
        return { ...state, fleets: state.fleets.filter((fleet) => fleet.id !== data.id && fleet.name !== data.name) };
      }

      return {
        ...state,
        fleets,
        updateFleetIsCompleted: true,
        updateFleetIsPending: false,
        updateFleetIsError: null,
      };
    }

    case UPDATE_FLEET_IS_PENDING:
      return {
        ...state,
        updateFleetIsCompleted: false,
        updateFleetIsPending: true,
        updateFleetIsError: null,
      };
    case UPDATE_FLEET_IS_ERROR:
      return {
        ...state,
        updateFleetIsCompleted: true,
        updateFleetIsPending: false,

        updateFleetIsError: action.error,
      };

    case REMOVE_FLEET: {
      const { data } = action;

      if (isNil(data)) {
        return state;
      }

      // keep fleets with different id and different name
      return {
        ...state,
        fleets: state.fleets.filter((fleet) => fleet.id !== data.id && fleet.name !== data.name),
        removeIsCompleted: true,
        removeIsPending: false,
        removeIsError: null,
      };
    }

    case REMOVE_FLEET_IS_PENDING:
      return {
        ...state,
        removeIsCompleted: false,
        removeIsPending: true,
        removeIsError: null,
      };
    case REMOVE_FLEET_IS_ERROR:
      return {
        ...state,
        removeIsCompleted: true,
        removeIsPending: false,
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        removeIsError: parseError(action.error.message),
      };

    case CLEAN_ERROR: {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (state[action.reducerProperty] && state[action.reducerProperty][action.errorIndex]) {
        return {
          ...state,
          [action.reducerProperty]:
            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            action.mode === 'property'
              ? null
              : // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                [...state[action.reducerProperty].slice(0, action.errorIndex), ...state[action.reducerProperty].slice(action.errorIndex + 1)],
        };
      }

      return {
        ...state,
      };
    }

    case SORT: {
      const {
        params: { sortSearchParam, sortSearchValue, value },
      } = action;

      return {
        ...state,
        sortBy: sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
        fleets: sort(state.fleets, {
          sortBy: sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
          sortSearchValue: sortSearchValue || value,
        }),
      };
    }

    case ACTION_PENDING:
      return { ...state, isPending: action.isPending };

    case 'RESET_FLEET_REDUCER': {
      const { reason } = action;

      if (reason === 'update') {
        // only reset the create or edit wizard part
        return {
          ...state,
          ...pick(INITIAL_STATE, [
            'addFleetIsCompleted',
            'addFleetIsPending',
            'addFleetIsError',
            'updateFleetIsCompleted',
            'updateFleetIsPending',
            'updateFleetIsError',
          ]),
        };
      }

      return INITIAL_STATE;
    }

    case 'RESET_REDUCER':
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default fleetReducer;
